import { PickleballGameType } from './../../_shared/models/enums/pickleball-game-type';
import { PickleballGameFormat } from './../../_shared/models/enums/pickleball-game-format';
import { FormGroup, FormBuilder, ReactiveFormsModule } from '@angular/forms';
import { Component, Input, EventEmitter, Output, inject, OnInit } from '@angular/core';
import { ScoreFormat, SetType } from '../../_shared/models/score-format.model';
import { BoardHelpService } from '../../match-tracker/tracker-board/board-help.service';
import { DisciplineEnum } from '../../_shared/models/csTypes/enums/discipline';
import { IonicModule } from '@ionic/angular';
import { CommonModule } from '@angular/common';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { AuthService } from '../../auth/auth.service';

@Component({
  selector: 'app-pickleball-match-format-form',
  templateUrl: './pickleball-match-format-form.component.html',
  styleUrls: ['./pickleball-match-format-form.component.scss'],
  standalone: true,
  imports: [
    IonicModule,
    CommonModule,
    ReactiveFormsModule,
    TranslateModule
  ]
})

export class PickleballMatchFormatFormComponent implements OnInit {
  private fb = inject(FormBuilder)
  private bhs = inject(BoardHelpService)
  public authService = inject(AuthService);
  private translateService = inject(TranslateService);

  @Input() matchFormat = 'SET3-S:1/WB2-G:11/S';
  @Input() setsLength = 0;
  @Input() dividerTitle = this.translateService.instant('Score format');
  @Output() updatedMatchFormat = new EventEmitter();
  scoreFormat: ScoreFormat;

  form: FormGroup;
  isLastSet = false;

  ngOnInit() {
    if (!this.matchFormat) this.matchFormat = 'SET3-S:1/WB2-G:11/S';
    this.scoreFormat = this.bhs.getScoreFormat(this.matchFormat, DisciplineEnum.PICKLEBALL);
    this.buildForm();
  }

  buildForm() {
    this.form = this.fb.group({
      isItTimed: [this.scoreFormat.timedSetDuration ? true : false],
      gameType: [this.scoreFormat.setType],
      numberOfGames: [this.scoreFormat.numberOfSets],
      numberOfPoints: [this.scoreFormat.numberOfPointsInGame],
      gameFormat: [this.scoreFormat.winBy2 ? PickleballGameFormat.WIN_BY_2 : PickleballGameFormat.DECIDING_POINT],
      isLastSetDifferent: [this.scoreFormat.lastSetNumberOfPoints ? true : false],
      lastSetGameType: [this.scoreFormat.lastSetGameType],
      lastSetNumberOfPoints: [this.scoreFormat.lastSetNumberOfPoints],
      lastSetGameFormat: [this.scoreFormat.lastSetGameFormat],
      numberOfMinutes: [this.scoreFormat.timedSetDuration || 10],
    });

    this.form
      .valueChanges
      .subscribe(
        () => {
          this.updatedMatchFormat.emit(this.getMatchFormat());
        }
      );

    this.form.get('isLastSetDifferent')
      .valueChanges
      .subscribe(
        (value) => {
          if (value) {
            this.form.get('lastSetGameType').setValue(this.form.get('gameType').value)
            this.form.get('lastSetNumberOfPoints').setValue(this.form.get('numberOfPoints').value)
            this.form.get('lastSetGameFormat').setValue(this.form.get('gameFormat').value)
          }
          this.updatedMatchFormat.emit(this.getMatchFormat());
        }
      );

    this.form.get('numberOfGames')
      .valueChanges
      .subscribe(
        (value) => {
          if (value === 1) {
            this.form.get('isLastSetDifferent').setValue(false)
          }
          this.updatedMatchFormat.emit(this.getMatchFormat());
        }
      );

    this.form.get('gameType')
      .valueChanges
      .subscribe(
        (value) => {
          if (value === 'MLP') {
            this.form.get('isLastSetDifferent').setValue(false);
            this.form.get('isLastSetDifferent').disable();
            this.form.get('numberOfPoints').setValue(21);
            this.form.get('gameFormat').setValue(PickleballGameFormat.DECIDING_POINT);
          } else {
            this.form.get('isLastSetDifferent').enable();
            this.form.get('numberOfPoints').enable();
            this.form.get('gameFormat').enable();
          }

          this.updatedMatchFormat.emit(this.getMatchFormat());
        }
      );

    this.form.get('isItTimed')
      .valueChanges
      .subscribe(
        (value) => {
          if (value) {
            this.form.get('numberOfGames').setValue(1);
            this.form.get('gameType').setValue(SetType.RALLY);
          }
          this.updatedMatchFormat.emit(this.getMatchFormat());
        }
      );

    this.updatedMatchFormat.emit(this.getMatchFormat())
  }

    private getMatchFormat() {
      const formValue = this.form.getRawValue();

      const sets = 'SET' + formValue.numberOfGames;

      let games = '';
      let points = '';
      if (formValue.isItTimed) {
        games = `-S:${formValue.numberOfMinutes}P`
        points = `-G/${this.getGameTypeForScoreFormat(formValue.gameType)}`
      } else {
        games = `-S:1/${formValue.gameFormat === PickleballGameFormat.WIN_BY_2 ? 'WB2' : 'NOAD'}`
        points = `-G:${formValue.numberOfPoints}/${this.getGameTypeForScoreFormat(formValue.gameType)}`
      }



      let finalSet = '';

      if (formValue.isLastSetDifferent) {
        finalSet = `-F:${formValue.lastSetNumberOfPoints}`
        finalSet += `/${this.getGameTypeForScoreFormat(formValue.lastSetGameType)}`
        finalSet += `/${formValue.lastSetGameFormat === PickleballGameFormat.WIN_BY_2 ? 'WB2' : 'NOAD'}`
      }

      return sets + games + points + finalSet;
    }

    // Header for action sheet
    customOptions(header) {
        return { header };
    }

    private getGameTypeForScoreFormat(gameType): string {
      if (gameType === PickleballGameType.STANDARD) return 'S';
      else if (gameType === PickleballGameType.RALLY) return 'R';
      else if (gameType === PickleballGameType.MLP) return 'M';
    }

}
